import { acquireAccessToken } from "./access-token-service";
import { LegacyIntegrationApiUrl } from "env-config";
import {
    BadRequestError,
    ForbiddenError,
    HttpError,
    ValidationFailuresResponse,
} from "components/ServerValidationErrors";

const baseApiUrl = (): string => LegacyIntegrationApiUrl().replace(/[/]$/, "");

export async function apiFetch<TResponse>(path: string, options: RequestInit): Promise<TResponse> {
    const url = `${baseApiUrl()}${path}`;
    const accessToken = await acquireAccessToken("api://legacy-integration-api", "access");
    const response = await fetch(url, {
        ...options,
        headers: { ...options.headers, Authorization: `Bearer ${accessToken}` },
    });
    if (response.ok) {
        const result = await response.json();
        return result as TResponse;
    } else if (response.status === 400) {
        throw new BadRequestError(
            response.status,
            response.statusText,
            (await response.json()) as ValidationFailuresResponse
        );
    } else if (response.status === 403) {
        throw new ForbiddenError(response.status, await response.text());
    } else {
        throw new HttpError(response.status, await response.text());
    }
}

export function toQuery(obj: any) {
    return Object.keys(obj)
        .filter((k) => obj[k] !== undefined)
        .filter((k) => obj[k] !== null)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
        .join("&");
}
